var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPinOutlined = function SvgLocationPinOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_7772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C7.2 0.45 6.125 0 5 0C3.875 0 2.8 0.45 2 1.25C1.2 2.05 0.75 3.1 0.75 4.25C0.75 6.525 2.925 8.425 4.1 9.45C4.25 9.6 4.4 9.725 4.525 9.825C4.675 9.95 4.85 10.025 5.025 10.025C5.2 10.025 5.375 9.95 5.525 9.825C5.625 9.725 5.775 9.6 5.95 9.45C7.075 8.425 9.25 6.525 9.25 4.225C9.25 3.1 8.8 2.05 8 1.25ZM5.525 9C5.35 9.15 5.225 9.275 5.1 9.375C5.05 9.425 4.95 9.425 4.9 9.375C4.775 9.275 4.65 9.15 4.475 9C3.375 8.025 1.35 6.25 1.35 4.225C1.35 2.225 3 0.575 5 0.575C7.025 0.575 8.65 2.2 8.65 4.225C8.65 6.25 6.625 8.025 5.525 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.125 2.25C4.1 2.25 3.25 3.1 3.25 4.125C3.25 5.15 4.1 6 5.125 6C6.15 6 7 5.15 7 4.125C7 3.1 6.15 2.25 5.125 2.25ZM5.125 5.4C4.425 5.4 3.85 4.825 3.85 4.125C3.85 3.425 4.425 2.85 5.125 2.85C5.825 2.85 6.4 3.425 6.4 4.125C6.4 4.825 5.825 5.4 5.125 5.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_7772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
};
export default SvgLocationPinOutlined;